<template>
  <div class="cooperation">
    <div class="banner">
      <p>业务合作</p>
      <p>让你更安心、更放心、更省心</p>
    </div>
    <div class="form">
      <el-form ref="form" :model="form" :rules="rules" label-width="80px">
        <el-row type="flex" justify="space-between">
          <el-col :span="11">
            <el-form-item label="联系人" prop="name">
              <el-input v-model="form.name" placeholder="请输入联系人"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="11">
            <el-form-item label="联系电话" prop="mobile">
              <el-input v-model="form.mobile" placeholder="请输入联系电话"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row type="flex" justify="">
          <el-col :span="11">
            <el-form-item label="验证码" prop="SMScode">
              <el-input v-model="form.SMScode" placeholder="请输入短信验证码" maxlength="6">
                <el-button class="send" slot="suffix" size="" type="primary" :disabled="!canSendCode" :loading="sendLoading" @click="getSMSCode">{{ sendCodeBtnText }}</el-button>
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div class="btn">
      <el-button type="primary" :loading="loading" @click="onSubmit">提交</el-button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
      form: {
        name: "",
        mobile: "",
        SMScode: "",
      },
      rules: {
        name: [{ required: true, message: "请输入联系人", trigger: "blur" }],
        mobile: [
          { required: true, message: "请输入联系电话", trigger: "blur" },
          { pattern: /^1[3456789]\d{9}$/, message: "请输入正确的手机号", trigger: "blur" },
        ],
        SMScode: [{ required: true, message: "请输入短信验证码", trigger: "blur" }],
      },
      sendLoading: false,
      canSendCode: true,
      countdown: 60,
      sendCodeBtnText: "发送验证码",
    }
  },
  created() {},
  methods: {
    getSMSCode() {
      if (this.form.mobile == "") {
        this.$message.error("手机号码不能为空")
      } else {
        if (!this.canSendCode) return

        this.sendLoading = true
        this.$axios
          .get(this.$api.SMSCode, {
            params: {
              mobile: this.form.mobile,
            },
          })
          .then(res => {
            this.sendLoading = false
            this.startCountdown()
            this.$message.success("验证码已发送，请查收短信")
            console.log("🚀 ~ getSMSCode ~ res:", res)
          })
          .catch(err => {
            this.sendLoading = false
            this.$message.error(err.desc)
          })
      }
    },
    startCountdown() {
      this.canSendCode = false
      this.countdown--

      if (this.countdown > 0) {
        setTimeout(this.startCountdown, 1000)
        this.sendCodeBtnText = `${this.countdown}秒后重发`
      } else {
        this.sendCodeBtnText = "发送验证码"
        this.canSendCode = true
        this.countdown = 60
      }
    },
    onSubmit() {
      // 清空表单
      this.$refs["form"].validate(valid => {
        if (valid) {
          this.loading = true
          setTimeout(() => {
            this.form = {
              name: "",
              mobile: "",
              SMScode: "",
            }
            this.$message.success("提交成功")
            this.loading = false
          }, 2000)
        } else {
          this.$message.error("提交失败")
          return false
        }
      })
    },
  },
}
</script>

<style scoped lang="less">
.cooperation {
  min-height: calc(100vh - 61px - 150px);
  .banner {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 374px;
    color: #fff;
    text-align: center;
    background: url("../assets/cooperation.png") no-repeat;
    background-size: cover;
    margin-bottom: 120px;
    p:first-child {
      font-size: 42px;
    }
    p:last-child {
      font-size: 30px;
    }
  }
  .form {
    max-width: 1000px;
    margin: 0 auto;
    /deep/ .el-input__suffix {
      right: 0;
    }
  }
  .btn {
    text-align: center;
    padding: 50px 0 100px;
    .el-button {
      width: 100px;
    }
  }
}
</style>
